export default "__VITE_ASSET__db6c1f45__"